
document.addEventListener('DOMContentLoaded', function() {
  // SVG arrow template
  const arrowSVG = `<span class="button-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.26192 0.180571C0.576414 -0.0889955 1.04989 -0.0525743 1.31946 0.26192L7.31946 7.26192C7.5602 7.54279 7.5602 7.95724 7.31946 8.23811L1.31946 15.2381C1.04989 15.5526 0.576414 15.589 0.26192 15.3195C-0.0525743 15.0499 -0.0889955 14.5764 0.180571 14.2619L5.76221 7.75001L0.180571 1.23811C-0.0889955 0.923613 -0.0525743 0.450138 0.26192 0.180571Z" fill="currentColor"/>
    </svg>
  </span>`;

  // Selectors for buttons that should NOT have the arrow
  const excludeSelectors = [
    '.product-form__submit',
    '.cart__ctas .button',
    '.cart__checkout-button',
    '.cart__update-button',
    'cart-remove-button .button',
    '.quantity__button',
    '.product-popup-modal__button',
    '.share-button__button',
    '.deferred-media__poster',
    '.mobile-facets__close-button',
    '.active-facets__button',
    '.hotspot',
    '.swiper-button-prev',
    '.swiper-button-next',
    'button[data-action="tab-trigger"]',
    '.wishlist-button',
    '.shopify-payment-button'
  ];

  // Find all buttons with class "button"
  const allButtons = document.querySelectorAll('.button, .shopify-challenge__button, .customer button');

  allButtons.forEach(button => {
    // Check if button should be excluded
    const shouldExclude = excludeSelectors.some(selector => {
      if (selector.includes(' ')) {
        // For nested selectors, check if button matches the last part and has the parent
        const parts = selector.split(' ');
        const lastPart = parts[parts.length - 1];
        if (button.matches(lastPart)) {
          // Check if any parent matches the first part
          let parent = button.parentElement;
          while (parent) {
            if (parent.matches(parts[0]) || parent.classList.contains(parts[0].replace('.', ''))) {
              return true;
            }
            parent = parent.parentElement;
          }
        }
      }
      return button.matches(selector);
    });

    // Add arrow if button is not excluded and doesn't already have one
    if (!shouldExclude && !button.querySelector('.button-arrow')) {
      button.insertAdjacentHTML('afterbegin', arrowSVG);
    }
  });

  // Observer for dynamically added buttons
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          const buttons = node.matches && node.matches('.button, .shopify-challenge__button, .customer button') 
            ? [node] 
            : node.querySelectorAll ? node.querySelectorAll('.button, .shopify-challenge__button, .customer button') : [];
          
          buttons.forEach(button => {
            const shouldExclude = excludeSelectors.some(selector => button.matches(selector));
            if (!shouldExclude && !button.querySelector('.button-arrow')) {
              button.insertAdjacentHTML('afterbegin', arrowSVG);
            }
          });
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
